(function () {
  function makeBundleId() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    return 'bundle-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function initInstance(root) {
    const handRadios = root.querySelectorAll('input[data-hand-radio]');
    const handGrids = root.querySelectorAll('.hand-grid');
    const countEl = root.querySelector('[data-selected-count]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const customizeToggle = root.querySelector('[data-customize-toggle]');
    const customizationPanel = root.querySelector('[data-customization-panel]');

    // Fixed component variants resolved server-side in Liquid (no customer choice).
    const shaftVariantId = root.getAttribute('data-shaft-variant-id');
    const shaftLabel = root.getAttribute('data-shaft-label');

    // Every pill-group whose selection is sent as a line item property —
    // Finish (always visible) plus everything in the toggleable panel.
    const customizeGroups = root.querySelectorAll('[data-customize-group]');
    // Only the panel's own groups reset to their first/default option when
    // the customer unchecks "Customize this build." Finish is untouched.
    const panelGroups = customizationPanel ? customizationPanel.querySelectorAll('[data-customize-group]') : [];
    const gripGroup = root.querySelector('[data-grip-group]');

    function getSelectedWedges() {
      const activeGrid = root.querySelector('.hand-grid:not(.is-hidden)');
      if (!activeGrid) return [];
      return Array.from(activeGrid.querySelectorAll('[data-wedge-checkbox]'))
        .filter(cb => cb.checked && !cb.disabled);
    }

    function switchHand() {
      const selectedRadio = root.querySelector('input[data-hand-radio]:checked');
      if (!selectedRadio) return;
      const targetIndex = selectedRadio.value;

      handGrids.forEach(grid => {
        if (grid.getAttribute('data-hand-index') === targetIndex) {
          grid.classList.remove('is-hidden');
        } else {
          grid.classList.add('is-hidden');
          grid.querySelectorAll('[data-wedge-checkbox]').forEach(cb => {
            cb.checked = false;
            cb.closest('.option-pill').classList.remove('is-active');
          });
        }
      });

      updateSummary();
    }

    function resetGroupToDefault(group) {
      const radios = group.querySelectorAll('.option-radio');
      radios.forEach((radio, index) => {
        radio.checked = index === 0;
        const pill = radio.closest('.option-pill');
        if (pill) pill.classList.toggle('is-active', index === 0);
      });
    }

    function toggleCustomizationPanel() {
      const isOn = !!(customizeToggle && customizeToggle.checked);
      if (customizationPanel) {
        customizationPanel.classList.toggle('is-hidden', !isOn);
      }
      if (!isOn) {
        panelGroups.forEach(resetGroupToDefault);
      }
    }

    // Every selectable option is sent as a line item property, even when
    // it's left at its default/"Standard" value — no skipping.
    function getCustomizationProperties() {
      const properties = {};

      customizeGroups.forEach(group => {
        const label = group.getAttribute('data-customize-group');
        const checked = group.querySelector('.option-radio:checked');
        if (!checked) return;

        const displayValue = checked.getAttribute('data-property-label') || checked.value;
        properties[label] = displayValue;
      });

      return properties;
    }

    function getSelectedFinish() {
      return root.querySelector('[data-customize-group="Finish"] .option-radio:checked');
    }

    function getSelectedGrip() {
      return gripGroup ? gripGroup.querySelector('.option-radio:checked') : null;
    }

    function updateSummary() {
      const wedges = getSelectedWedges();
      const wedgeCount = wedges.length;
      if (countEl) countEl.textContent = wedgeCount;
      if (addBtn) addBtn.disabled = wedgeCount === 0;
    }

    async function submitBundleToCart() {
      const wedges = getSelectedWedges();
      if (wedges.length === 0) return;

      const wedgeCount = wedges.length;
      const bundleId = makeBundleId();
      const customProps = getCustomizationProperties();
      const baseProperties = Object.assign({ '_bundle_id': bundleId }, customProps);

      const itemsPayload = [];

      // One line item per selected wedge, all customization properties attached,
      // plus a plain true/false flag a checkout validation Function can read
      // without needing to know anything about metaobjects or upcharge amounts.
      const selectedFinishForFlag = getSelectedFinish();
      const finishUpchargeAmount = selectedFinishForFlag
        ? (parseFloat(selectedFinishForFlag.getAttribute('data-upcharge-amount')) || 0)
        : 0;
      const wedgeProperties = Object.assign(
        {
          '_component': 'Wedge Head',
          '_finish_upcharge_required': finishUpchargeAmount > 0 ? 'true' : 'false',
          'Shaft': shaftLabel || ''
        },
        baseProperties
      );

      wedges.forEach(cb => {
        // If a paid finish is selected, add the matching finish-upcharge
        // bundle variant instead of the plain wedge variant — the bundle
        // product already includes the upcharge, so no separate Finish
        // Upcharge line item is needed for it.
        const bundleVariantId = cb.getAttribute('data-bundle-variant-id');
        const useBundle = finishUpchargeAmount > 0 && bundleVariantId;
        const variantId = useBundle ? bundleVariantId : cb.value;

        itemsPayload.push({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: wedgeProperties
        });
      });

      // Shaft always gets added — no customer choice, quantity scales with wedge count.
      // No properties needed here; the assembler reads the Shaft/Grip info off the wedge line instead.
      if (shaftVariantId) {
        itemsPayload.push({
          id: parseInt(shaftVariantId, 10),
          quantity: wedgeCount
        });
      }

      // Grip: the customer-selected variant, quantity scales with wedge count.
      const selectedGrip = getSelectedGrip();
      if (selectedGrip) {
        itemsPayload.push({
          id: parseInt(selectedGrip.value, 10),
          quantity: wedgeCount
        });
      }

      // No separate Finish Upcharge line needed anymore — when the finish
      // has an upcharge, it's already baked into the bundle variant added above.

      const defaultLabel = addBtn ? addBtn.textContent : '';

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding to Cart...';
      }

      try {
        const response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload })
        });

        if (response.ok) {
          window.location.href = '/cart';
        } else {
          const errData = await response.json().catch(() => null);
          alert((errData && errData.description) || 'Could not add items to cart. Please check variant stock.');
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = defaultLabel;
          }
        }
      } catch (err) {
        console.error('Cart API error:', err);
        alert('Something went wrong adding these to your cart. Please try again.');
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = defaultLabel;
        }
      }
    }

    handRadios.forEach(radio => radio.addEventListener('change', switchHand));
    root.querySelectorAll('[data-wedge-checkbox]').forEach(cb => {
      cb.addEventListener('change', function () {
        this.closest('.option-pill').classList.toggle('is-active', this.checked);
        updateSummary();
      });
    });
    root.querySelectorAll('.option-radio').forEach(radio => {
      radio.addEventListener('change', function () {
        const group = this.closest('[data-customize-group]');
        if (group) {
          group.querySelectorAll('.option-pill').forEach(pill => pill.classList.remove('is-active'));
        }
        const pill = this.closest('.option-pill');
        if (pill) pill.classList.add('is-active');
      });
    });
    if (customizeToggle) customizeToggle.addEventListener('change', toggleCustomizationPanel);
    if (addBtn) addBtn.addEventListener('click', submitBundleToCart);

    switchHand();
    toggleCustomizationPanel();
  }

  function initAllInstances() {
    document.querySelectorAll('.wedge-configurator').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInstances);
  } else {
    initAllInstances();
  }
})();